/**
 * Stable identifiers for final-check issue categories. Carried on
 * `IssueLocator.kind` so UI consumers (sidebar Issues Panel, telemetry) can
 * branch on category without parsing user-facing copy.
 *
 * Lives in `editor-utils` (not next to the validator in `editor/lib/`)
 * because `editor-utils/dataParser.js` is the biggest emitter and
 * `editor-utils` must not import from `editor` — that would create a
 * circular dependency. `pagesValidator.js` re-exports for ergonomics.
 */
const ISSUE_KIND = Object.freeze({
  MISSING_PHOTO: 'missing-photo',
  BROKEN_PHOTO: 'broken-photo',
  LOW_DPI: 'low-dpi',
  MISSING_TEXT: 'missing-text',
  SAFE_ZONE: 'safe-zone',
  FOIL_COVER_OVERFLOW: 'foil-cover-overflow',
  PAGE_COUNT: 'page-count',
  LEGAL_CONFIRMATION: 'legal-confirmation',
  UNSUPPORTED_GLYPH: 'unsupported-glyph',
  GLYPH_CHECK_UNAVAILABLE: 'glyph-check-unavailable',
});

export default ISSUE_KIND;
